import { createSelector } from 'reselect';

export const storeName = 'forgotPasswordCode';

export const forgotPasswordCodeSelector = state => ({ ...state[storeName] });

export const forgotPasswordResultSelector = createSelector(
  forgotPasswordCodeSelector,
  forgotPasswordCode => forgotPasswordCode,
);
